<template>
    <div class="clearfix pb-3 px-0 ml-0">
         <!-- Abdullah26 added this code here  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0" v-if="this.flg != 1">HR Settings<span>
                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / HR Settings / Job Positions</span>
        </h4>

        <!-- Abdullah changed classes here . was clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3 -->
        <b-alert v-model="hasDraft" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info"
            dismissible>There are some draft job positions.</b-alert>


        <div class="row no-margin mt-4"> <!-- Abdullah added this div here -->
            <div class="ibox col-md-12 px-4 employee-table-wrapper">
                <!-- Abdullah achnaged class here. was clearfix row py-2 mb-2 border-bottom  -->
                <div class="ibox-title dashboard_title px-0">
                    <!-- Abdullah achnaged class here. was col-sm-3 px-3 company-form-box-title and added h4-->
                    <h4>Job Positions</h4>
                </div>

                <div class="row"> <!-- Abdullah added this div here -->
                    <div class="col-md-6"> <!-- Abdullah achnaged class here. was col-sm-4  -->
                        <div class="custom-search w-100"> <!-- Abdullah removed float-right from class -->
                            <b-input-group class="mb-0">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search.." v-model="search"
                                    @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>

                    <!-- Abdullah commneted this div -->
                    <!-- <div class="col-sm-5 float-right text-right px-0" v-if="permission >= 2">
                        <b-button id="show-btn" class="mr-3" @click="addNew(true)">Add Multiple Job Positions</b-button>
                        <b-button id="show-btn" class="" @click="addNew(false)">Add Job Position</b-button>
                    </div> -->

                    <!-- Abdullah added this div here -->
                    <div class="col-md-6 text-right">
                        <b-button id="show-btn" class="mr-3 custom-wizard-btn" @click="addNew(true)">Add Multiple Job
                            Positions</b-button>
                        <b-button id="show-btn" class="btn-primary" @click="addNew(false)">Add Job Position</b-button>
                    </div>
                </div>



                <!-- Abdullah Moved it up.This table was below next block of code.  -->
                <div class="ibox-content px-0 mt-4"> <!-- Abdullah chnaged class here. was col-sm-12  px-0-->
                    <b-overlay :show="showoverlay_list" rounded="sm" class=""> <!-- Abdullah added class" " -->
                        <table class="table"> <!-- Abdullah removed class list-tale. -->
                            <thead>
                                <tr class="table-head">
                                    <td style="width: 60px;" class="">#SL</td>
                                    <!-- Abdullah removed class added style. -->
                                    <td>Job Position title</td>
                                    <td>Is Reporting Manager</td>
                                    <td style="width: 100px;" v-if="permission >= 2" class="">Action</td>
                                    <!-- Abdullah removed class added style. -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2"
                                    v-for="(jobposition, n) in paginatedData" :key="jobposition.id">
                                    <!-- alpha fix- added class text-center  -->
                                    <td class="align-middle list-columns text-center">{{ jobposition.index }}</td>
                                    <!-- Abdullah removed class col-md-1 and pl-5. -->

                                    <!-- Abdullah commented this  -->
                                    <!-- <td>
                                        <b-icon v-if="jobposition.draft_flg == 1" icon="pencil-square" v-b-tooltip.hover title="Has Draft Data"></b-icon>
                                    </td> -->
                                    <td class="align-middle list-columns"> <!-- Abdullah removed class col-md-5. -->
                                        <div class="">{{ jobposition.name }}</div>
                                    </td>
                                    <td class="align-middle list-columns"> <!-- Abdullah removed class col-md-3. -->
                                        <div v-if="jobposition.is_manager == 1">Yes</div>
                                        <div v-else>No</div>
                                    </td>

                                    <td class="clearfix align-middle" v-if="permission >= 2">
                                        <!-- Abdullah removed class col-md-6 . -->
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown"
                                                    class="dropdown-toggle clearfix action-dropdown-toggle"
                                                    style="font-size: 16px;" href="#" role="button"
                                                    data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"><b-icon
                                                        icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu"
                                                    aria-labelledby="actionDropdown">

                                                    <!-- Abdullah commented this code  -->
                                                    <!-- <b-button-group class="mr-1">
                                                        <b-button class="mr-3 rounded edit-btn" title="Edit Job Position" @click="editJobposition(jobposition.id)">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                        </b-button>
                                                        <b-button v-if="permission == 2" class="rounded delete-btn" title="Delete Jobposition" @click="deleteJobposition(jobposition.id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group> -->

                                                    <b-button-group class="mr-1">
                                                        <b-button variant="outline-secondary" title="Edit Job Position"
                                                            @click="editJobposition(jobposition.id)">
                                                            <b-icon icon="pencil" class="mr-2"
                                                                aria-hidden="true"></b-icon>Edit
                                                        </b-button>
                                                        <!-- alpha fix- added a big big space here betwwen job posotopn  -->
                                                        <b-button v-if="permission == 2" variant="outline-secondary"
                                                            title="Delete Job position"
                                                            @click="deleteJobposition(jobposition.id)">
                                                            <b-icon icon="trash" class="mr-2"
                                                                aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="row py-2 no-margin"> <!-- Abdullah chnaged class here. was px-3 -->
                            <div class="col-md-12 p-0 no-margin"> <!-- Abdullah added this div -->
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length"
                                            :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                                </ul>
                                <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                                    base-url="#" prev-text="Previous" next-text="Next" first-number
                                    last-number></b-pagination-nav>
                            </div>
                        </div>


                        <div v-if="this.flg == 1" class="mt-3">
                            <div class="text-center"> <!-- Abdullah added this div -->
                                <b-button type="button" @click="set_go_next(1)" variant="primary"
                                    class="btn-primary mt-3 mr-3">Go Next</b-button>
                                <!-- Abdullah chnaged class here. was flot-right mt-3 mr-3 -->
                                <b-button type="button" @click="setfinish(1)" variant="success"
                                    class="btn-primary custom-wizard-btn mt-3 mx-3">Finish</b-button>
                                <!-- Abdullah chnaged class here. was flot-right mt-3 mr-3 -->
                                <b-button type="button" @click="set_go_back(1)" variant="primary"
                                    class="btn-primary mt-3 mr-3">Go Back</b-button>
                                <!-- Abdullah chnaged class here. was flot-right mt-3 mr-3 -->

                            </div>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-sm-12  px-0" v-if="permission >= 2">
                <b-modal id="bv-modal-job-positions" size="lg" hide-footer :title="department_details">
                    <!-- Abdullah chnaged title here. was title="Job Position(s) Details" -->
                    <b-overlay :show="showoverlay" rounded="sm">

                        <b-form @submit.stop.prevent="onSubmit" class="">

                            <input type="hidden" v-model="fdata.id" name="id">
                            <div class="clearfix">
                                <div class="px-3">
                                    <template v-if="addtype == true">
                                        <b-form-group id="name-group" label="Job Position Title(s)"
                                            class="required-field gray-textarea" label-for="name"
                                            description="Add new job position title in new line for multiple entry">
                                            <!-- Abdullah added class here. gray-textarea-->
                                            <b-form-textarea id="name" name="name" rows="5" v-model="fdata.name"
                                                v-validate="{ required: true }" :state="validateState('name')"
                                                aria-describedby="name-feedback"
                                                data-vv-as="Job Position Title"></b-form-textarea>
                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                                }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                    <template v-else>

                                        <b-form-group id="name-group" label="Job Position Title" class="required-field"
                                            label-for="name">
                                            <b-input-group>
                                                <!-- // AbdullahALC chnaged added this code, added class radius-8 -->
                                                <b-form-input class="radius-8" id="name" name="name"
                                                    v-model="fdata.name" v-validate="{ required: true, min: 3 }"
                                                    :state="validateState('name')" aria-describedby="name-feedback"
                                                    data-vv-as="Job Position Title"></b-form-input>
                                                <b-input-group-append v-if="draft_data['name']" v-b-tooltip.hover
                                                    :title="xdata['name']"><b-icon icon="pencil-square"
                                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                                    }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </template>

                                    <b-form-group id="is_manager-group" label="" label-for="is_manager">
                                        <b-input-group>
                                            <b-form-checkbox id="is_manager" v-model="fdata.is_manager"
                                                name="is_manager" value="1" unchecked-value="0">Is
                                                Reporting Manager</b-form-checkbox>
                                            <b-input-group-append v-if="draft_data['is_manager']"><b-icon
                                                    icon="pencil-square"
                                                    class="ml-1 mt-1"></b-icon></b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>



                                <template v-if="(Object.keys(draft_data).length > 0) && (permission == 2)">
                                    <div class="btn-wrapper text-center pt-5"> <!-- Abdullah added this div -->
                                        <b-button type="submit" class="btn-primary">Approve</b-button>
                                        <!-- Abdullah added class removed varient -->
                                        <b-button class="btn-primary"
                                            v-if="(Object.keys(draft_data).length > 0) && (permission == 2)"
                                            @click="resetJobposition(fdata.id)" type="button"
                                            variant="primary">Reset</b-button>
                                        <!-- Abdullah added class and make varient to primary. -->
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="btn-wrapper text-center pt-5"> <!-- Abdullah added this div -->
                                        <!-- Abdullah after live chnaged this btn  -->
                                        <b-button class="btn-primary" type="submit" variant="primary">
                                            {{ is_edit_mode ? 'Update' : 'Submit' }}
                                        </b-button>
                                    </div>
                                </template>

                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>

                <b-modal id="bv-modal-jobposition-draft" size="lg" hide-footer title="Jobposition Details">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="saveDraftJobposition">
                            <div class="clearfix">
                                <div class="px-3">
                                    <input type="hidden" v-model="draftdata.id" name="id">

                                    <b-form-group id="name-group" label="Title" class="required-field" label-for="name">
                                        <b-form-input id="name" name="name" v-model="draftdata.name"
                                            v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                            aria-describedby="name-feedback"
                                            data-vv-as="Jobposition Title"></b-form-input>
                                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group id="is_manager-group" label="" label-for="is_manager">
                                        <b-form-checkbox id="is_manager" v-model="draftdata.is_manager"
                                            name="is_manager" value="1" unchecked-value="0">Is Reporting
                                            Manager</b-form-checkbox>
                                    </b-form-group>
                                    <b-button class="btn-primary" type="submit" variant="primary">Save</b-button>
                                    <!-- Abdullah added class and make varient to primary. -->
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>




            <div class="col-sm-12  px-0 mt-5" v-if="draft_jobpositions.length > 0">

                <div class="px-3 mb-2 company-form-box-title">New Job Position (Waiting for Approval)</div>

                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table list-tables">
                        <thead>
                            <tr class="table-head">
                                <td class="pl-5">#</td>
                                <td>Job Position title</td>
                                <td>Is Reporting Manager</td> <!-- Abdullah chnaged this td. was reporting manager  -->
                                <td v-if="permission >= 2" class="float-right">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2"
                                v-for="(jobposition, n) in draft_jobpositions" :key="jobposition.id">
                                <td class="col-md-1 align-middle list-columns pl-5">{{ parseInt(n + 1) }}</td>
                                <td class="col-md-5 align-middle list-columns">
                                    <div class="">{{ jobposition.name }}</div>
                                </td>
                                <td class="col-md-3 align-middle list-columns">
                                    <div v-if="jobposition.is_manager == 1">Yes</div>
                                    <div v-else>No</div>
                                </td>

                                <td class="clearfix col-md-6 align-middle" v-if="permission >= 2">
                                    <div class="float-right mr-2 position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">

                                                    <!-- Abdullah Commented this  -->
                                                    <!-- <b-button v-if="permission == 2" class="mr-3 rounded edit-btn" title="Approve Jobposition" @click="approveJobposition(jobposition.id)">
                                                        <b-icon icon="check2" class="mr-2" aria-hidden="true" ></b-icon>Approve
                                                    </b-button>
                                                    <b-button class="mr-3 rounded edit-btn" title="Edit Jobposition" @click="editDraftJobposition(jobposition.id)">
                                                        <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                    </b-button>
                                                    <b-button class="rounded delete-btn" title="Delete Jobposition" @click="deleteDraftJobposition(jobposition.id)">
                                                        <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                    </b-button> -->

                                                    <b-button v-if="permission == 2" variant="outline-secondary"
                                                        title="Approve Jobposition"
                                                        @click="approveJobposition(jobposition.id)">
                                                        <b-icon icon="check2" class="mr-2"
                                                            aria-hidden="true"></b-icon>Approve
                                                    </b-button>
                                                    <b-button variant="outline-secondary" title="Edit Jobposition"
                                                        @click="editDraftJobposition(jobposition.id)">
                                                        <b-icon icon="pencil" class="mr-2"
                                                            aria-hidden="true"></b-icon>Edit
                                                    </b-button>
                                                    <b-button variant="outline-secondary" title="Delete Jobposition"
                                                        @click="deleteDraftJobposition(jobposition.id)">
                                                        <b-icon icon="trash" class="mr-2"
                                                            aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-overlay>
            </div>


        </div>

    </div>
</template>


<script>
export default {

    mounted() {
        this.permission = this.$acl['jobposition/details'];
    },
    props: ['flg'],
    data() {

        return {

            jobpositions: [],

            draft_jobpositions: [],

            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            go_back: false,
            go_next: false,
            finish: false,

            showoverlay: false,
            showoverlay_list: false,

            errormsg: [],
            fdata: { id: null, name: '', is_manager: 0 },
            xdata: {},
            draftdata: {},
            file: null,

            search: '',
            length: 20,
            temp_length: 20,
            people: 0,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            pagination: { currentPage: 1, pages: 1 },

            addtype: false,

            permission: 0,

            hasDraft: false,
            draft_data: [],

            // Abdullah added this line
            department_details: 'Job Position Details',

            // <!-- Abdullah after live chnaged this  -->
            is_edit_mode: false,

        }
    },
    methods: {
        showMessage: function () {
            let tmp_flg = 0;
            if (this.jobpositions.length > 0) tmp_flg = 1;
            let childdata = { flg: tmp_flg, successmsg: this.successmsg, warningmsg: this.warningmsg, dangermsg: this.dangermsg, move_next: this.go_next, move_back: this.go_back, finish: this.finish };
            this.$emit('childToParent', childdata);
        },
        set_go_back(x) {
            this.go_next = false;
            this.go_back = true;
            this.finish = false;

            if (x == 1)
                this.showMessage();
        },
        set_go_next(x) {
            this.go_next = true;
            this.go_back = false;
            this.finish = false;

            if (x == 1)
                this.showMessage();
        },
        disable_set_go_next() {
            this.go_next = false;
        },
        setfinish(x) {
            this.finish = true;

            this.go_next = false;
            this.go_back = false;

            if (x == 1)
                this.showMessage();
        },
        addNew(x) {
            this.addtype = x;
            this.resetForm();
            // Abdullah added this if else
            if (x == true) {
                this.department_details = 'Add Multiple Job Positions';
            } else {
                this.department_details = 'Add Job Position';
            }
            this.$bvModal.show('bv-modal-job-positions');
            //this.newagent = true;

            // <!-- Abdullah after live chnaged this  -->
            this.is_edit_mode = false;
        },

        getDraftJobpositionData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/jobposition/list/draft', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.draft_jobpositions = response.data;

                if (this.draft_jobpositions.length > 0)
                    this.hasDraft = true;
                else
                    this.hasDraft = false;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editDraftJobposition: function (x) {
            this.addtype = false;
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.showoverlay = true;
            axios.get(this.$api_url + '/jobposition/details/draft', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.draftdata = response.data;
                this.$validator.reset();
                this.showoverlay = false;
                this.$bvModal.show('bv-modal-jobposition-draft');
            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });;
        },
        saveDraftJobposition(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                let formData = new FormData();

                for (let [key, value] of Object.entries(this.draftdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/jobposition/save/draft', formData)
                    .then(function (response) {
                        this.getDraftJobpositionData();
                        this.successmsg = 'Saved!';
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        this.resetForm();
                        this.$bvModal.hide('bv-modal-jobposition-draft');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },
        deleteDraftJobposition: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this draft jobposition.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/jobposition/delete/draft', formData).then(function (response) {
                            this.getDraftJobpositionData();
                            this.$bvToast.toast('Deleted!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },

        approveJobposition: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to approve this draft jobposition.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/jobposition/approve/draft', formData).then(function (response) {

                            this.getJobpositions();
                            this.getDraftJobpositionData();

                            this.$bvToast.toast('Approved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },
        resetJobposition: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to reset this jobposition data.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        formData.append('type', 1);

                        axios.post(this.$api_url + '/clear/draft', formData).then(function (response) {

                            this.getJobpositions();
                            this.editJobposition(x);

                            this.$bvToast.toast('Saved', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },

        getDraftData: function (x) {

            if (!this.checkNet()) return false;
            this.hasDraft = false;
            let currentObj = this;
            this.showoverlay = true;

            let formData = new FormData();
            formData.append('id', x);
            formData.append('type', 1);

            axios.post(this.$api_url + '/cdata/draft', formData).then(function (response) {


                this.draft_data = response.data;

                if (this.draft_data.length > 0)
                    this.hasDraft = false;

                this.showoverlay = false;

                for (let [key, value] of Object.entries(this.draft_data)) {
                    this.fdata[key] = value;
                }

            }.bind(this));
        },




        getJobpositions: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/jobposition/list', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.jobpositions = response.data;
                this.people = response.data.length;
                //this.showMessage();

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editJobposition: function (x) {
            this.department_details = 'Edit Job Position';
            if (!this.checkNet()) return false;
            this.addtype = false;
            let currentObj = this;
            this.warningmsg = null;
            this.successmsg = null;
            this.showMessage();

            // Abdullah after live added this
            this.is_edit_mode = true;

            this.showoverlay = true;
            axios.get(this.$api_url + '/jobposition/details', {
                params: {
                    id: x
                }
            }).then(function (response) {

                for (let [key, value] of Object.entries(response.data)) {
                    this.xdata[key] = value;
                    this.fdata[key] = value;
                }


                this.$validator.reset();
                this.showoverlay = false;

                this.getDraftData(x);

                this.$bvModal.show('bv-modal-job-positions');

            }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                    currentObj.errormsg = error.response.data.errors;
                });
        },
        deleteJobposition: function (jobposition_id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this job position.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', jobposition_id);

                        axios.post(this.$api_url + '/jobposition/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                //this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.jobpositions = response.data.jobpositions;
                                this.resetPagination();
                            }
                            else {
                                //this.warningmsg = response.data.meg;
                                //alert(response.data.meg);
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }
                            this.showoverlay_list = false;
                            //this.showMessage();

                        }.bind(this));
                    }
                })
                .catch(function (error) {
                    currentObj.showoverlay_list = false;
                    currentObj.serverError(error);
                });

        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', is_manager: 0 };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;

            this.warningmsg = null;
            this.successmsg = null;
            //this.showMessage();

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/jobposition/save', formData, config)
                    .then(function (response) {
                        this.getJobpositions();
                        this.getDraftJobpositionData();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        this.resetForm();
                        //this.movenext = true;
                        //this.showMessage();
                        this.$bvModal.hide('bv-modal-job-positions');
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getJobpositions();
        this.getDraftJobpositionData();
        Fire.$on('reloadUsers', () => { this.getJobpositions() });
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.jobpositions;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
